import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { menuService } from "../services/menu.service";

export const fetchMenus = createAsyncThunk(
  "menu/fetchAll",
  async (_, thunkAPI) => {
    try {
      return await menuService.getMenus();
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch menus");
    }
  },
);

export const addMenu = createAsyncThunk("menu/add", async (menu, thunkAPI) => {
  try {
    return await menuService.createMenu(menu);
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data?.message || "Failed");
  }
});

export const editMenu = createAsyncThunk(
  "menu/edit",
  async ({ id, menu }, thunkAPI) => {
    try {
      await menuService.updateMenu(id, menu);
      return { menuId: id, ...menu };
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed");
    }
  },
);

export const removeMenu = createAsyncThunk(
  "menu/remove",
  async (id, thunkAPI) => {
    try {
      await menuService.deleteMenu(id);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed");
    }
  },
);

const menuSlice = createSlice({
  name: "menu",
  initialState: { menus: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenus.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenus.fulfilled, (state, action) => {
        state.loading = false;
        state.menus = action.payload;
      })
      .addCase(fetchMenus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addMenu.fulfilled, (state, action) => {
        state.menus.push(action.payload);
      })
      .addCase(editMenu.fulfilled, (state, action) => {
        const idx = state.menus.findIndex(
          (m) => m.menuId === action.payload.menuId,
        );
        if (idx !== -1)
          state.menus[idx] = { ...state.menus[idx], ...action.payload };
      })
      .addCase(removeMenu.fulfilled, (state, action) => {
        state.menus = state.menus.filter((m) => m.menuId !== action.payload);
      });
  },
});
export default menuSlice.reducer;
